import { useEnvContext, useWebStoreContext } from "contexts";
import { FeaturesFlags } from "helpers";
import { useAppDispatch } from "hooks";
import React from "react";
import { onOpenPopUp, onOpenPopUpV2 } from "redux/slices";
import { InfoIcon } from "utils/svgIcons";
import { CustomButton } from "./styles";

interface FTUEInfoButtonProps {
	className?: string;
}

const FTUEInfoButton: React.FC<FTUEInfoButtonProps> = ({ className }) => {
	const dispatch = useAppDispatch();
	const { isFeatureFlagEnabled } = useEnvContext();
	const { userTracker } = useWebStoreContext();

	const handleInfoButtonClick = () => {
		if (isFeatureFlagEnabled(FeaturesFlags.FTUE_V2)) {
			dispatch(
				onOpenPopUpV2({
					variant: "tutorial-loyalty-shop-v2",
					id: "tutorial-loyalty-shop-v2",
					replaceIfExists: true
				})
			);
			return;
		}
		dispatch(onOpenPopUp("tutorial-loyalty-shop"));
	};

	return (
		<>
			{!!userTracker && (
				<CustomButton
					id={"info-button-loyalty-shop"}
					className={className}
					aria-label="info button"
					onClick={handleInfoButtonClick}
				>
					<InfoIcon width={35} height={35} />
				</CustomButton>
			)}
		</>
	);
};

export default FTUEInfoButton;
